import { HttpClient } from 'api/http-client';
import { StatusUpdateTemplate } from '../type';

const NAMESPACE = '/templates';

export interface IframelyError {
  error: string;
  status: 403;
}

class StatusUpdatesTemplatesHttpClient extends HttpClient {
  public findAll(): Promise<StatusUpdateTemplate[]> {
    return this.get<StatusUpdateTemplate[]>(`${NAMESPACE}/status-updates`);
  }
}

export const StatusUpdatesTemplatesAPI = new StatusUpdatesTemplatesHttpClient();
